'use client';

import {
  QueryClient,
  QueryClientContext,
  QueryClientProvider,
} from '@tanstack/react-query';
import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import type { PersonalFinanceEnvironment } from '../types';
import getVisitorId from '../utils/getVisitorId';

export interface ICalculatorConfig {
  environment: PersonalFinanceEnvironment;
  visitorId: string;
}

export const CalculatorConfigContext = createContext<ICalculatorConfig | null>(
  null,
);

interface IFallbackQueryClientProviderProps {
  children: ReactNode;
}

function FallbackQueryClientProvider({
  children,
}: IFallbackQueryClientProviderProps) {
  const [queryClient] = useState(() => new QueryClient());
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}

interface ICalculatorContextProviderProps {
  environment: PersonalFinanceEnvironment;
  children: ReactNode;
}

export default function CalculatorContextProvider({
  environment,
  children,
}: ICalculatorContextProviderProps) {
  const [visitorId, setVisitorId] = useState('');
  const existingClient = useContext(QueryClientContext);

  useEffect(() => {
    setVisitorId(getVisitorId());
  }, []);

  const content = existingClient ? (
    children
  ) : (
    <FallbackQueryClientProvider>{children}</FallbackQueryClientProvider>
  );

  return (
    <CalculatorConfigContext.Provider value={{ environment, visitorId }}>
      {content}
    </CalculatorConfigContext.Provider>
  );
}
